import earthIcon from "public/images/icon/earth.png";
import fireIcon from "public/images/icon/fire.png";
import waterIcon from "public/images/icon/water.png";
import windIcon from "public/images/icon/wind.png";

import { ElementEnum } from "@sorcery/db";

export const earth = earthIcon;
export const fire = fireIcon;
export const water = waterIcon;
export const wind = windIcon;

export const elementToImgMap = {
  [ElementEnum.Earth]: earthIcon,
  [ElementEnum.Fire]: fireIcon,
  [ElementEnum.Water]: waterIcon,
  [ElementEnum.Air]: windIcon,
};
